<template>
  <div class="info-main">
    <InfoButtonNew/>
    <div class="table">
      <div class="table-header">
        <div class="table-header-date">
          日付
        </div>

        <div class="table-header-content">
          内容
        </div>
      </div>

      <div
        v-for="(info, index) in infos"
        :key="index"
        class="table-cell"
        @click="editInfo(info)"
        >

        <div class="table-cell-date">
          {{ sentDate(info) }}
        </div>

        <div class="table-cell-content">
          {{ info.get('content') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import InfoButtonNew from '@/components/Info/ButtonNew'

export default {
  components: {
    InfoButtonNew
  },

  computed: {
    ...mapState('info', [
      'infos'
    ])
  },

  methods: {
    editInfo: function (info) {
      this.$router.push({
        name: 'info-edit',
        params: { id: info.id }
      })
    },

    sentDate: function (info) {
      const date = info.get('date')
      if (date) {
        return format(date, 'YYYY/M/D H:mm')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-date {
    padding: 5px;
    width: 25%;
  }

  &-content {
    padding: 5px;
    width: 75%;
  }
}

@import '@/styles/_table.scss';
</style>
